import styled, { css } from 'styled-components';

export const LiveToggleWrapper = styled.div`
  color: ${props => props.theme.colors.selectedColor};
  background-color: ${props => props.theme.colors[props.bgColor]};
  margin-right: 0.5em;
  border: 1px solid ${props => props.theme.colors.lightGray}; 
  border-radius: 2px;
  width: 4.5em;
  height: 1.94em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: ${props => props.theme.fontSets.narrowMedium};
 ${props => props.theme.mediaQueries.tablet_big_down}{
    height: 1.84em;
  }
  ${props => !props.isToday && css`
    opacity: 1;
  `};
  ${props => props.liveCounter === 0 && css`
    opacity: 1;
  `};
`;
